import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handleDeleteButton } from "../HandleSlice/HandleSlice";
import CustomUpdateToast from "../components/CustomUpdateToast/CustomUpdateToast";

const CustomDeleteToast = ({
  text,
  timerRefCurrent,
  secondDelete,
  setCounterReverse,
}) => {
  const [counter, setCounter] = useState(secondDelete);

  const dispatch = useDispatch();

  const cancelClickHandler = (
    timerRefCurrent,
    secondDelete,
    setCounterReverse,
  ) => {
    if (timerRefCurrent) {
      clearInterval(timerRefCurrent);
      setCounterReverse(secondDelete);
      dispatch(handleDeleteButton([]));
      toast.dismiss();
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((counter) => counter - 1);
    }, 1000);
    if (counter === 0) {
      clearInterval(interval);
      toast.dismiss();
    }
    return () => {
      clearInterval(interval);
    };
  }, [counter]);

  return (
    <>
      <div className="flex items-center justify-center gap-2">
        <p className="font-bold text-[14px]">{text}</p>
        <div className="flex">
          <div className="w-[30px] flex justify-center items-center pt-1 bg-green-600 text-[#eee] rounded-full">
            {counter}
          </div>
          <button
            className="bg-red-600 text-stone-200 rounded-lg hover:bg-[#ff5656] mr-2 w-[50px] h-[30px] text-[12px]"
            onClick={() =>
              cancelClickHandler(
                timerRefCurrent,
                secondDelete,
                setCounterReverse,
              )
            }
          >
            لغو
          </button>
        </div>
      </div>
    </>
  );
};

const Toastify = (
  statuses,
  text,
  btnText,
  AsyncDeleteItem,
  timerRefCurrent,
  secondDelete,
  setCounterReverse,
) => {
  switch (statuses) {
    case "success":
      toast.success(`${text}`, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      break;
    case "error":
      toast.error(`${text}`, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      break;
    case "warn":
      toast.warn(`${text}`, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      break;
    case "info":
      toast.info(`${text}`, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      break;
    case "customUpdate":
      toast(<CustomUpdateToast text={text} btnText={btnText} />, {
        autoClose: false,
        draggable: false,
        closeOnClick: false,
      });
      break;
    case "customDelete":
      toast(
        <CustomDeleteToast
          text={text}
          btnText={btnText}
          AsyncDeleteItem={AsyncDeleteItem}
          timerRefCurrent={timerRefCurrent}
          secondDelete={secondDelete}
          setCounterReverse={setCounterReverse}
        />,
        {
          autoClose: false,
          pauseOnHover: false,
          pauseOnFocusLoss: false,
          closeButton: false,
          closeOnClick: false,
          draggable: false,
        },
      );
      break;
    default:
      return;
  }
};

function forceOnlyNumberInput(event) {
  let updatedValue = event.target.innerText;
  if (Number.isNaN(+updatedValue) === true) {
    updatedValue = updatedValue.slice(0, -1);
    return (event.target.innerText = updatedValue);
  }
}

function formatNum(num, separator, fraction) {
  var str = num.toLocaleString("en-US");
  // str = str.replace(/\./, fraction);
  str = str.replace(/,/g, separator);
  return str;
}

function numberWithSlash(x) {
  if (x) {
    x = x.toString();
    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) x = x.replace(pattern, "$1/$2");
  }
  return x;
}

function timestampToPersianDate(timeStamp) {
  const date = new Date(timeStamp);
  const weekDay = date.toLocaleDateString("fa-IR", { weekday: "long" });
  const monthDay = date.toLocaleDateString("fa-IR", { day: "numeric" });
  const year = date.toLocaleDateString("fa-IR", { year: "numeric" });
  const monthName = date.toLocaleDateString("fa-IR", { month: "long" });

  const dateString = `${weekDay} ${monthDay} ${monthName} ${year}`;
  return dateString;
}

function timestampToNumericPersianDate(timeStamp) {
  const date = new Date(timeStamp);
  const weekDay = date.toLocaleDateString("fa-IR", { weekday: "long" });
  const monthDay = date.toLocaleDateString("fa-IR", { day: "numeric" });
  const year = date.toLocaleDateString("fa-IR", { year: "numeric" });
  const monthName = date.toLocaleDateString("fa-IR", { month: "numeric" });

  const dateString = `${weekDay} ${monthDay} / ${monthName} / ${year}`;
  return dateString;
}

const areArraysEqual = (arr1, arr2) => {
  const ids1 = arr1.map((item) => item.id);
  const ids2 = arr2.map((item) => item.id);
  if (ids1.length !== ids2.length) return false;
  return ids1.every((id, index) => id === ids2[index]);
};

// تابع تبدیل اعداد فارسی به لاتین
const convertPersianToLatinDigits = (text) => {
  const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const latinDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  let result = text;
  persianDigits.forEach((digit, index) => {
    result = result.replace(new RegExp(digit, "g"), latinDigits[index]);
  });
  return result;
};

export {
  Toastify,
  forceOnlyNumberInput,
  formatNum,
  numberWithSlash,
  timestampToPersianDate,
  areArraysEqual,
  timestampToNumericPersianDate,
  convertPersianToLatinDigits,
};
